// extracted by mini-css-extract-plugin
export var blue = "_h-f";
export var brand = "_h-b";
export var darkGrey = "_h-e";
export var disabled = "_h-4";
export var disabledSubtle = "_h-5";
export var error = "_h-6";
export var green = "_h-g";
export var grey = "_h-d";
export var icon = "_h-0";
export var inherit = "_h-a";
export var lightGrey = "_h-c";
export var orange = "_h-i";
export var pink = "_h-k";
export var primary = "_h-1";
export var purple = "_h-l";
export var red = "_h-j";
export var secondary = "_h-2";
export var success = "_h-9";
export var tertiary = "_h-3";
export var warning = "_h-7";
export var warningSecondary = "_h-8";
export var white = "_h-m";
export var yellow = "_h-h";